import React, { useRef } from "react";
import { getImageURL } from "../../_helper/utils/image";
import { useLocation, useSearchParams } from "react-router-dom";
import CuSpinner from "../../common_component/component/CuSpinner";

const ProfileAvatarLg = ({
  isLoading,
  img,
  full_name,
  phone,
  onProfilePhoto,
  deleteProfile,
  role_name,
}) => {
  const fileInputRef = useRef(null);
  const handleClick = () => {
    fileInputRef.current.click();
  };
  const [searchParams] = useSearchParams();
  const option = searchParams.get("option");

  return (
    <>
      <div
        className="border border-[#00000050 ] w-[156px] h-[156px] rounded-full m-auto relative flex justify-center items-center"
        onClick={option === "edit-profile" ? handleClick : null}
      >
        {!isLoading ? (
          <>
            {img ? (
              <img
                className="w-full h-full rounded-full"
                src={getImageURL(img)}
                alt=""
              />
            ) : (
              <div className="w-full h-full overflow-hidden flex justify-center items-center bg-[#C7EAC9] rounded-full text-6xl font-bold">
                {full_name ? full_name.split("")[0] : ""}
              </div>
            )}
            {option === "edit-profile" && (
              <div className="absolute w-[43px] h-[43px] border border-[#00000033] rounded-full z-3 bottom-[0] right-0">
                <img
                  className="h-full w-full rounded-full"
                  src="https://cufront-assets.s3.amazonaws.com/images/camera.png"
                  alt=""
                />
              </div>
            )}
          </>
        ) : (
          <CuSpinner />
        )}
      </div>
      {option === "edit-profile" && (
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={onProfilePhoto}
          accept="image/*"
        />
      )}
      {option === "edit-profile" && (
        <div className="mt-3 flex gap-2">
          {img && (
            <button
              className="border h-10 rounded px-4"
              onClick={deleteProfile}
            >
              Delete{" "}
            </button>
          )}
          <button
            className="border h-10 rounded px-4 flex-1"
            onClick={handleClick}
            // ref={fileInputRef}
          >
            Upload New{" "}
          </button>
        </div>
      )}
      <div className="font-bold text-[32px] leading-[36.8px] mt-2">
        {full_name}
      </div>
      <div className="text-[20px] leading-[23px] text-[#000000B2] mt-3">
        {phone}
      </div>
      <div className="text-[20px] leading-[23px] text-[#000000B2] mt-3 capitalize ">
        {role_name}
      </div>
    </>
  );
};

export default ProfileAvatarLg;
